import React, { useEffect, useRef } from 'react';
import clientImage from '../assets/images/transfuel.jpg';
import client2 from '../assets/images/oryx.jpg';
import client3 from '../assets/images/hass.png';
import client4 from '../assets/images/asas.png';

function Testimonials() {
  const testimonials = [
    {
      text: "Exceptional service! Our 40ft containers were delivered on time and in perfect condition. Highly recommended for reliable logistics.",
      name: "Emilio Costa",
      position: "Operations Manager, Transfuel.",
      image: clientImage
    },
    {
      text: "Handled our loose cargo with great care. The team ensured smooth customs clearance and timely delivery. Would use their services again!",
      name: "Douglas Omenda",
      position: "Logistics Coordinator, Oryx.",
      image: client2
    },
    {
      text: "Seamless container transport service! Their team provided real-time tracking and excellent support throughout the process.",
      name: "Mahmoud Salat",
      position: "Supply Chain Director, HASS Petroleum Ltd.",
      image: client3
    },
    {
      text: "We have been using their transport services for over a year now, and they have never disappointed. Great communication and professionalism!",
      name: "Faraj Abri",
      position: "CEO, Asas Group of Companies.",
      image: client4
    }
  ];
  
  const owlCarouselRef = useRef(null);
  
  useEffect(() => {
    // Check if jQuery and owl carousel are available
    const $ = window.jQuery;
    if ($ && $.fn.owlCarousel && owlCarouselRef.current) {
      // Initialize Owl Carousel
      const owlCarousel = $(owlCarouselRef.current);
      
      // Destroy carousel if it's already initialized
      if (typeof owlCarousel.data('owl.carousel') !== 'undefined') {
        owlCarousel.trigger('destroy.owl.carousel');
      }
      
      // Initialize carousel
      owlCarousel.owlCarousel({
        loop: true,
        margin: 20,
        nav: false,
        dots: true,
        autoplay: true,
        autoplayTimeout: 5000,
        responsive: {
          0: { items: 1 },
          768: { items: 2 }
        }
      });
    }
    
    // Cleanup function
    return () => {
      const $ = window.jQuery;
      if ($ && $.fn.owlCarousel && owlCarouselRef.current) {
        $(owlCarouselRef.current).trigger('destroy.owl.carousel');
      }
    };
  }, []);

  return (
    <section className="client_section layout_padding">
      <div className="container">
        <div className="heading_container">
          <h2>What Our <span>Clients Say</span></h2>
          <p>Trusted by businesses and individuals for safe, reliable, and efficient transportation solutions.</p>
        </div>
        <div className="client_container">
          <div className="carousel-wrap">
            <div ref={owlCarouselRef} className="owl-carousel owl-theme">
              {testimonials.map((testimonial, index) => (
                <div className="item" key={index}>
                  <div className="box">
                    <div className="detail-box">
                      <p>{testimonial.text}</p>
                    </div>
                    <div className="client_id">
                      <div className="img-box">
                        <img src={testimonial.image} alt="Client" className="img-1" />
                      </div>
                      <div className="name">
                        <h6>{testimonial.name}</h6>
                        <p>{testimonial.position}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;